import { MIDDLE_STYLE } from '@constants/responsive';
import { Button } from 'antd';
import React from 'react';
import { SocialIcon } from '..';
import { useAppDispatch } from '@core/configureStore';
import { openDrawer } from '@core/features';

type Props = {
  style?: React.CSSProperties;
};

const BrowsePexelsButton = ({ style }: Props) => {
  const dispatch = useAppDispatch();
  const handleBrowsePexels = () => {
    dispatch(
      openDrawer({
        drawerName: 'pexelsPhotoBrowseDrawer',
      })
    );
  };
  return (
    <Button onClick={handleBrowsePexels} style={{ ...MIDDLE_STYLE, ...style }}>
      <SocialIcon platform="pexels" width={20} />
      <span style={{ marginLeft: 10 }}>Browse Pexels Photos</span>
    </Button>
  );
};

export default BrowsePexelsButton;
